import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useTimeSlots(coachId) {
  const [timeSlots, setTimeSlots] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.coaches.time_slots.index(coachId))
      .then((response) => {
        setTimeSlots(response.data.data);
      });
  }, []);

  return timeSlots;
}
